var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXyz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3854_55728)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0771 29.5313V27.6472L36.7511 20.8688H31.1638V18.7031H39.8263V20.6089L34.1523 27.3657H39.9995V29.5313H31.0771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2025 34.0575H20.582L22.8993 28.9466L18.2432 18.7031H20.8636L24.177 26.3695L27.5121 18.7031H30.1541L23.2025 34.0575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1495 29.5313L12.2259 25.8714L9.30234 29.5313H6.40039L10.71 24.1389L6.63861 18.7031H9.47559L12.2043 22.3414L14.933 18.7031H17.7916L13.7202 24.1389L18.0298 29.5313H15.1495Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3854_55728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXyz);
export default __webpack_public_path__ + "static/media/xyz.fe0b43822a6a2f3c6ba41c4b10c12d9d.svg";
export { ForwardRef as ReactComponent };